import { render, staticRenderFns } from "./ResourceVisit.vue?vue&type=template&id=0a74a147&scoped=true"
import script from "./ResourceVisit.vue?vue&type=script&lang=js"
export * from "./ResourceVisit.vue?vue&type=script&lang=js"
import style0 from "./ResourceVisit.vue?vue&type=style&index=0&id=0a74a147&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a74a147",
  null
  
)

export default component.exports